import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { productsData } from '../../mocks/products';

const Products = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-32">
        {/* Header */}
        <section className="bg-gradient-to-b from-gray-50 to-white py-16">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <h1 className="font-serif text-5xl md:text-6xl font-light text-gray-900 mb-6">
              Our Products
            </h1>
            <p className="text-lg text-gray-700 max-w-3xl leading-relaxed">
              Discover our complete range of professional red light and near-infrared therapy solutions. From full-body therapy beds to portable panels and facial masks, we offer cutting-edge technology for both commercial and residential applications.
            </p>
          </div>
        </section>

        {/* Products Grid */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
              {productsData.map((product) => (
                <Link 
                  key={product.id} 
                  to={`/products/${product.id}`}
                  className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all group cursor-pointer"
                >
                  <div className="relative aspect-square overflow-hidden bg-gray-100">
                    <img 
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    {product.badge && (
                      <div className="absolute top-4 right-4 bg-gray-900 text-white px-3 py-1 text-xs font-medium rounded-full">
                        {product.badge}
                      </div>
                    )}
                  </div>
                  <div className="p-6">
                    <div className="text-xs font-medium text-teal-600 mb-2">
                      {product.category}
                    </div>
                    <h3 className="text-base font-medium text-gray-900 mb-3 line-clamp-2 min-h-[48px]">
                      {product.name}
                    </h3>
                    <div className="flex items-center justify-between">
                      <span className="text-base font-medium text-teal-600">
                        Request a Quote
                      </span>
                      <i className="ri-arrow-right-line text-gray-400 group-hover:text-teal-600 transition-colors"></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gray-900 text-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="font-serif text-4xl md:text-5xl font-light mb-6">
              Need Help Choosing?
            </h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Our team is here to help you select the perfect therapy solution for your needs. Contact us for personalized recommendations and quotes.
            </p>
            <Link 
              to="/contact"
              className="inline-block bg-teal-500 text-white px-8 py-3 rounded-md text-sm font-medium hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact Us
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Products;
